/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExtendedPaymentSplit } from './ExtendedPaymentSplit';
import {
    ExtendedPaymentSplitFromJSON,
    ExtendedPaymentSplitFromJSONTyped,
    ExtendedPaymentSplitToJSON,
} from './ExtendedPaymentSplit';

/**
 * 
 * @export
 * @interface ExtendedUsdcGate
 */
export interface ExtendedUsdcGate {
    /**
     * 
     * @type {number}
     * @memberof ExtendedUsdcGate
     */
    price: number;
    /**
     * 
     * @type {Array<ExtendedPaymentSplit>}
     * @memberof ExtendedUsdcGate
     */
    splits: Array<ExtendedPaymentSplit>;
}

/**
 * Check if a given object implements the ExtendedUsdcGate interface.
 */
export function instanceOfExtendedUsdcGate(value: object): value is ExtendedUsdcGate {
    let isInstance = true;
    isInstance = isInstance && "price" in value && value["price"] !== undefined;
    isInstance = isInstance && "splits" in value && value["splits"] !== undefined;

    return isInstance;
}

export function ExtendedUsdcGateFromJSON(json: any): ExtendedUsdcGate {
    return ExtendedUsdcGateFromJSONTyped(json, false);
}

export function ExtendedUsdcGateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtendedUsdcGate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'price': json['price'],
        'splits': ((json['splits'] as Array<any>).map(ExtendedPaymentSplitFromJSON)),
    };
}

export function ExtendedUsdcGateToJSON(value?: ExtendedUsdcGate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'price': value.price,
        'splits': ((value.splits as Array<any>).map(ExtendedPaymentSplitToJSON)),
    };
}

